import AddressInfo from "./AddressInfo";
import AlertAction from "./AlertAction";
import AlertLabel from "./AlertLabel";
import Avatar from "./Avatar";
import BGLoading from "./BGLoading";
import HeaderIconTitle from "./HeaderIconTitle";
import HeaderWarrantyStatus from "./HeaderWarrantyStatus";
import ImageSmooth from "./ImageSmooth";
import LabelEmpty from "./LabelEmpty";
import Loading from "./Loading";
import RewardStatus from "./RewardStatus";
import SeatZoneGrid from "./SeatZoneGrid";
import TitleReserve from "./TitleReserve";

const EXPORT = {
  AddressInfo,
  AlertAction,
  AlertLabel,
  Avatar,
  BGLoading,
  HeaderIconTitle,
  HeaderWarrantyStatus,
  ImageSmooth,
  LabelEmpty,
  Loading,
  RewardStatus,
  SeatZoneGrid,
  TitleReserve,
};

export default EXPORT;
